import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Clock, ListChecks } from "lucide-react";

export default function StatusScreen() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const waitlist = user?.status === "waitlist";

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FCFCFA] px-6">
      <div className="max-w-lg text-center sc-fade-up">
        <div className="w-16 h-16 rounded-full bg-[#F7EEC7] flex items-center justify-center mx-auto">
          {waitlist ? <ListChecks className="w-7 h-7 text-[#48020C]" /> : <Clock className="w-7 h-7 text-[#48020C]" />}
        </div>
        <div className="sc-label text-[#48020C] mt-8">{waitlist ? "Lista de espera" : "Candidatura recebida"}</div>
        <h1 data-testid="status-title" className="font-serif text-4xl sm:text-5xl text-[#26130E] mt-4">
          {waitlist ? "Estás na waiting list" : "A tua candidatura está pendente"}
        </h1>
        <p className="text-[#6E6359] mt-5 leading-relaxed">
          {waitlist
            ? "Neste momento não há vaga, mas mantivemos o teu lugar na lista de espera. Avisamos-te assim que abrir uma vaga."
            : "Obrigada, " + (user?.name?.split(" ")[0] || "") + "! A nossa equipa vai avaliar o teu pedido de adesão em breve. Entra novamente mais tarde para veres o estado."}
        </p>
        <button data-testid="status-logout-btn" onClick={handleLogout} className="mt-10 border border-[#48020C] text-[#48020C] hover:bg-[#48020C] hover:text-[#FCFCFA] rounded-full px-8 py-3 transition-colors">
          Terminar sessão
        </button>
      </div>
    </div>
  );
}
